var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirValveOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 23,
    viewBox: "0 0 78 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M3.91,23H0V14.85A5.937,5.937,0,0,1,5.97,8.96H78v3.86H5.97a2.044,2.044,0,0,0-2.06,2.03V23Z",
    fill: "#6a7084"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M34.41,1.21,45.48,8.6,56.56,1.21V19.24L45.48,11.85,34.41,19.24Z",
    fill: "#2f323a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M55.91,2.42v15.6l-5.85-3.9-4.57-3.05-4.57,3.05-5.85,3.9V2.42l5.85,3.9,4.57,3.05,4.57-3.05,5.85-3.9M57.22,0,55.19,1.36l-5.85,3.9L45.49,7.82,41.64,5.26l-5.85-3.9L33.75,0V20.44l2.03-1.36,5.85-3.9,3.85-2.56,3.85,2.56,5.85,3.9,2.03,1.36V0Z",
    fill: "#6a7084"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirValveOff);
export default __webpack_public_path__ + "static/media/air_valve_off.3536829fd844ecbb7e3724f1c894b2c1.svg";
export { ForwardRef as ReactComponent };